// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-root {
  color: #fff;
}

/* ===== STATS ===== */
.stats-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-bottom: 25px;
}

.stat-box {
  background: radial-gradient(circle at top, #0f172a, #020617);
  border-radius: 16px;
  padding: 20px;
  border: 1px solid #1e293b;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.stat-box svg {
  width: 28px;
  height: 28px;
  color: #facc15;
}

.stat-title {
  color: #94a3b8;
  font-size: 14px;
}

.stat-box h2 {
  font-size: 30px;
  margin: 5px 0;
}

.positive {
  color: #22c55e;
  font-size: 13px;
}

.negative {
  color: #ef4444;
  font-size: 13px;
}

/* ===== PANELS ===== */
.middle-row {
  display: grid;
  grid-template-columns: 1.4fr 1fr;
  gap: 20px;
}

.panel {
  background: radial-gradient(circle at top, #0f172a, #020617);
  border-radius: 18px;
  padding: 20px;
  border: 1px solid #1e293b;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}

.panel-header h3 {
  font-size: 20px;
}

.panel-header p {
  font-size: 13px;
  color: #94a3b8;
}

.view-all {
  color: #facc15;
  font-size: 14px;
  cursor: pointer;
}

/* ===== LIST ===== */
.list-item {
  background: #020617;
  border-radius: 14px;
  padding: 14px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  border: 1px solid #1e293b;
}

.list-item h4 {
  font-size: 15px;
}

.list-item p {
  font-size: 13px;
  color: #94a3b8;
}

/* ===== BADGES ===== */
.badge {
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
}

.badge.yellow { background: #3a2e05; color: #facc15; }
.badge.blue { background: #0b2a4a; color: #60a5fa; }
.badge.green { background: #052e1b; color: #22c55e; }
.badge.red { background: #3b0a0a; color: #ef4444; }

/* ===== DOT STATUS ===== */
.dot {
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.dot::before {
  content: "";
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.dot.green::before { background: #22c55e; }
.dot.red::before { background: #ef4444; }
/* ===== LIVE MARKET RATES ===== */
.market-card {
  margin-top: 30px;
  padding: 24px;
  border-radius: 18px;
    grid-column: 1 / -1;

  width: 100%;              /* ✅ FULL WIDTH */
  max-width: 100%;          /* ✅ FORCE FULL */

  background: linear-gradient(
    180deg,
    rgba(35, 30, 10, 0.95),
    rgba(15, 13, 5, 0.95)
  );
  border: 1px solid rgba(234, 179, 8, 0.25);
}
.dashboard-bottom {
  grid-column: 1 / -1;   /* full row le lega */
}

.market-card h2 {
  font-size: 22px;
  font-weight: 600;
}

.market-subtitle {
  font-size: 14px;
  color: #9ca3af;
  margin-bottom: 20px;
}

.market-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.market-item {
  text-align: center;
}

.market-label {
  font-size: 14px;
  color: #9ca3af;
}

.market-item h3 {
  font-size: 26px;
  margin: 6px 0;
  color: #fff;
}

.market-up {
  font-size: 14px;
  color: #22c55e;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,4DAA4D;EAC5D,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,4DAA4D;EAC5D,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;AACjB;;AAEA,gBAAgB,mBAAmB,EAAE,cAAc,EAAE;AACrD,cAAc,mBAAmB,EAAE,cAAc,EAAE;AACnD,eAAe,mBAAmB,EAAE,cAAc,EAAE;AACpD,aAAa,mBAAmB,EAAE,cAAc,EAAE;;AAElD,2BAA2B;AAC3B;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA,qBAAqB,mBAAmB,EAAE;AAC1C,mBAAmB,mBAAmB,EAAE;AACxC,kCAAkC;AAClC;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;IACjB,mBAAmB;;EAErB,WAAW,eAAe,iBAAiB;EAC3C,eAAe,WAAW,iBAAiB;;EAE3C;;;;GAIC;EACD,yCAAyC;AAC3C;AACA;EACE,mBAAmB,IAAI,qBAAqB;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;AAChB","sourcesContent":[".dashboard-root {\n  color: #fff;\n}\n\n/* ===== STATS ===== */\n.stats-row {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 20px;\n  margin-bottom: 25px;\n}\n\n.stat-box {\n  background: radial-gradient(circle at top, #0f172a, #020617);\n  border-radius: 16px;\n  padding: 20px;\n  border: 1px solid #1e293b;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.stat-box svg {\n  width: 28px;\n  height: 28px;\n  color: #facc15;\n}\n\n.stat-title {\n  color: #94a3b8;\n  font-size: 14px;\n}\n\n.stat-box h2 {\n  font-size: 30px;\n  margin: 5px 0;\n}\n\n.positive {\n  color: #22c55e;\n  font-size: 13px;\n}\n\n.negative {\n  color: #ef4444;\n  font-size: 13px;\n}\n\n/* ===== PANELS ===== */\n.middle-row {\n  display: grid;\n  grid-template-columns: 1.4fr 1fr;\n  gap: 20px;\n}\n\n.panel {\n  background: radial-gradient(circle at top, #0f172a, #020617);\n  border-radius: 18px;\n  padding: 20px;\n  border: 1px solid #1e293b;\n}\n\n.panel-header {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 15px;\n}\n\n.panel-header h3 {\n  font-size: 20px;\n}\n\n.panel-header p {\n  font-size: 13px;\n  color: #94a3b8;\n}\n\n.view-all {\n  color: #facc15;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n/* ===== LIST ===== */\n.list-item {\n  background: #020617;\n  border-radius: 14px;\n  padding: 14px 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n  border: 1px solid #1e293b;\n}\n\n.list-item h4 {\n  font-size: 15px;\n}\n\n.list-item p {\n  font-size: 13px;\n  color: #94a3b8;\n}\n\n/* ===== BADGES ===== */\n.badge {\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n}\n\n.badge.yellow { background: #3a2e05; color: #facc15; }\n.badge.blue { background: #0b2a4a; color: #60a5fa; }\n.badge.green { background: #052e1b; color: #22c55e; }\n.badge.red { background: #3b0a0a; color: #ef4444; }\n\n/* ===== DOT STATUS ===== */\n.dot {\n  font-size: 13px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.dot::before {\n  content: \"\";\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n}\n\n.dot.green::before { background: #22c55e; }\n.dot.red::before { background: #ef4444; }\n/* ===== LIVE MARKET RATES ===== */\n.market-card {\n  margin-top: 30px;\n  padding: 24px;\n  border-radius: 18px;\n    grid-column: 1 / -1;\n\n  width: 100%;              /* ✅ FULL WIDTH */\n  max-width: 100%;          /* ✅ FORCE FULL */\n\n  background: linear-gradient(\n    180deg,\n    rgba(35, 30, 10, 0.95),\n    rgba(15, 13, 5, 0.95)\n  );\n  border: 1px solid rgba(234, 179, 8, 0.25);\n}\n.dashboard-bottom {\n  grid-column: 1 / -1;   /* full row le lega */\n}\n\n.market-card h2 {\n  font-size: 22px;\n  font-weight: 600;\n}\n\n.market-subtitle {\n  font-size: 14px;\n  color: #9ca3af;\n  margin-bottom: 20px;\n}\n\n.market-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 20px;\n}\n\n.market-item {\n  text-align: center;\n}\n\n.market-label {\n  font-size: 14px;\n  color: #9ca3af;\n}\n\n.market-item h3 {\n  font-size: 26px;\n  margin: 6px 0;\n  color: #fff;\n}\n\n.market-up {\n  font-size: 14px;\n  color: #22c55e;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
